module.exports = __webpack_public_path__ + "static/media/Fresh_Rose_TH2.9433fcb4.png";